export const RED = '#d1411e';
export const WHITE = '#ffffff';
export const DARK_WHITE = '#f2f2f2';
export const GREY = '#d9d9d9';
export const LIGHT_BLACK = '#282c34';
export const BLACK = '#1a1a1a';
export const GOLD = '#c7a252';
export const GREEN = '#00b3b3';
export const TRANSPARENT_BLACK = 'rgba(0, 0, 0, 0.5)';
